import { useRef, useState, useEffect } from "react";
import Select, {InputAction} from 'react-select';
import { Modal } from 'react-responsive-modal';
import makeAnimated from 'react-select/animated'
import ToggleInput from "./inputs/ToggleInput";
import { useCollectionContext } from "../context/CollectionContext";
import { db } from "../db";
import Swal from "sweetalert2";
import { updateImageTags } from "../api-helper";
import { useAccountContext } from "../context/AccountContext";
import { isUndefined } from "cropperjs";
import { ReactComponent as CloseIcon } from "../images/icons/white-close.svg";
import { useWindowSize } from "../hooks/useWindowSize";
import electronBridge from "../utils/electronBridge";
import { ReactComponent as DoubleRightIcon } from "../images/icons/white-double-right.svg";
import { ReactComponent as DoubleLeftIcon } from "../images/icons/white-double-left.svg";

const animatedComponents = makeAnimated()

export default function FullImageViewer(props){
    const collectionContext = useCollectionContext()
    const accountContext = useAccountContext()
    const { effectiveWidth, effectiveHeight } = useWindowSize(true)

    const imageContainerRef = useRef(null);
    const [transform, setTransform] = useState({
      scale: 1,
      translateX: 0,
      translateY: 0,
    });
    const [isDragging, setIsDragging] = useState(false);
    const [lastMousePosition, setLastMousePosition] = useState({ x: 0, y: 0 });
    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([]); 
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [inputTag, setInputTag] = useState("");
    const [tag, setTag] = useState(props.tag)
    const [tagLoading, setTagLoading] = useState(false);
  
    const handleWheel = (e) => {
        e.preventDefault();
      
        // mouse position in container coords
        const rect = imageContainerRef.current.getBoundingClientRect();
        const cx = e.clientX - rect.left;
        const cy = e.clientY - rect.top;
      
        // zoom factor (symmetrical in/out)
        const step = 1.1; // 10% per notch
        const k = e.deltaY < 0 ? step : 1 / step;
      
        const oldScale = transform.scale;
        const newScale = Math.min(Math.max(oldScale * k, 0.1), 10);
      
        // image-space point under cursor BEFORE zoom
        const px = (cx - transform.translateX) / oldScale;
        const py = (cy - transform.translateY) / oldScale;
      
        // choose new translation so that (px,py) stays under (cx,cy) AFTER zoom
        const newTranslateX = cx - px * newScale;
        const newTranslateY = cy - py * newScale;
      
        const newTransform = { scale: newScale, translateX: newTranslateX, translateY: newTranslateY };
        setTransform(newTransform);
        localStorage.setItem('imageViewerTransform', JSON.stringify(newTransform));
      };

    const toFileUrl = (filePath) => {
        return filePath;
      }

    // Add useEffect to initialize transform from localStorage
    // useEffect(() => {
    //     const savedTransform = localStorage.getItem('imageViewerTransform');
    //     if (savedTransform) {
    //         setTransform(JSON.parse(savedTransform));
    //     }
    // }, []);

    // Attach wheel listener with { passive: false } so preventDefault works
    useEffect(() => {
        const el = imageContainerRef.current;
        if (!el) return;
        el.addEventListener('wheel', handleWheel, { passive: false });
        return () => el.removeEventListener('wheel', handleWheel);
    }, [transform]);

    // Add window resize handler
    useEffect(() => {
        const handleResize = () => {
            const savedTransform = localStorage.getItem('imageViewerTransform');
            if (savedTransform) {
                setTransform(JSON.parse(savedTransform));
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleMouseDown = (e) => {
      setIsDragging(true);
      setLastMousePosition({ x: e.clientX, y: e.clientY });
    };
  
    const handleMouseMove = (e) => {
      if (!isDragging) return;
  
      const { x, y } = lastMousePosition;
      const deltaX = e.clientX - x;
      const deltaY = e.clientY - y;
  
      const newTransform = {
        ...transform,
        translateX: transform.translateX + deltaX,
        translateY: transform.translateY + deltaY,
      };
  
      setTransform(newTransform);
      localStorage.setItem('imageViewerTransform', JSON.stringify(newTransform));
      setLastMousePosition({ x: e.clientX, y: e.clientY });
    };
  
    const handleMouseUp = () => {
      setIsDragging(false);
    };
  
    const imageStyle = {
      transform: `scale(${transform.scale}) translate(${transform.translateX / transform.scale}px, ${transform.translateY / transform.scale}px)`,
      transformOrigin: '0 0',
      transition: isDragging ? 'none' : 'transform 0.1s ease-out',
      cursor: isDragging ? 'grabbing' : 'grab',
    };

    const openTagModal = () => {
        setOptions([]);

        const combinedTags = [...collectionContext.tags, ...collectionContext.collectionTags];
        const uniqueTags = [...new Set(combinedTags)];

        const sortedTags = uniqueTags.sort((a, b) => a.localeCompare(b));
        setOptions(sortedTags.map(tag => ({ value: tag, label: tag })));
        setOpen(true);
    }

    const editTagOnImage = () => {
        setTagLoading(true);
        let multiOptions = "";
        let initTag
        let concate

        setTimeout(() => {
            if (isUndefined(props.tag) == false) {
                initTag = props.tag + ","
            } else {
                initTag = "";
            }
            if (selectedOptions !== "" && !selectedOptions.includes("undefined")) {
                selectedOptions.map((arrValue) => {
                    if (!initTag.includes(arrValue.value)){
                        multiOptions += arrValue.value + ",";
                    }
                })
                initTag += multiOptions;
            }


        }, 1000)

        setTimeout(() => {
            if (inputTag !== "") {
                if (!initTag.includes(inputTag)){
                    concate = initTag + inputTag
                } else {
                    concate = initTag
                }
            } else {
                concate = initTag;
            }   
            if (concate.endsWith(',')) {
                concate = concate.slice(0, -1);
            }
            if (concate.startsWith(',')) {
                concate = concate.substring(1);
            }
            if (concate == '') {
                Swal.fire({
                    color: "#190A4E",
                    title: "Tag Empty",
                    text: "You cannot tag an image with an empty tag. Please add a tag to the image before proceeding.",
                    icon: "info",
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false
                })
                setTagLoading(false);
                return;
            }  
            setTag(concate)
            db.images.update(props.id, {tag: concate}).then(async(updated) => {
                if (updated) {
                    if (props.isMyCollection) {
                        // Update the tag in the images table if it exists
                        let generatedImages = [];
                        await db.images.reverse().toArray((images) => {
                            generatedImages = images;
                        });
                        let imageInImagesTable;
                        generatedImages.forEach((image) => {
                            if (image.hash === props.hash) {
                                imageInImagesTable = image;
                            }
                        })
                        if (imageInImagesTable) {
                            db.images.update(imageInImagesTable.id, { tag: concate });
                        } else {
                            console.log("Image not found in the images table");
                        }
                        console.log("Update Image Tags Route: ", props.hash);
                        updateImageTags(accountContext.accountDetails.accountNo, props.hash, concate)

                    } else {
                        let collectionImages = [];
                        await db.collectedImages.reverse().toArray((images) => {
                            collectionImages = images;
                        });
                        let imageInCollectionTable;
                        collectionImages.forEach((image) => {
                            if (image.hash === props.hash) {
                                imageInCollectionTable = image;
                            }
                        })
                        if (imageInCollectionTable) {
                            db.collectedImages.update(imageInCollectionTable.id, { tag: concate });
                        } else {
                            console.log("Image not found in the collection table");
                        }
                    }
                    Swal.fire({
                        title:"Success",
                        text:"Your image was successfully tagged",
                        icon:"success",
                        timer: 1000,
                        showConfirmButton: false
                    }).then(() => {
                        setTagLoading(false);
                        setInputTag("");
                        // setClearTags(false);
                        setSelectedOptions([]);
                        // if (!props.isMyCollection) {
                        //     props.refreshImages();
                        // }
                        props.setTag(concate)
                    })
                    setOpen(false)
                }
            })

        }, 2500)

    }

    const handleKeyDown = (e) => {
        if (e.key === "Escape") props.closeImageViewer?.();
        if (e.key === "ArrowLeft") props.onPrev?.();
        if (e.key === "ArrowRight") props.onNext?.();

        if (e.key === "Enter") {
            editTagOnImage();
        }
        
        if (e.key === "Escape") {
            props.closeImageViewer();    
        }
        
        // Handle Ctrl+ and Ctrl- for zooming
        if (e.ctrlKey) {
            if (e.key === '+' || e.key === '=' || e.code === 'NumpadAdd') {
                e.preventDefault(); // Prevent the default browser zoom
                
                // Simulate a wheel event with negative deltaY (zoom in)
                const simulatedEvent = {
                    preventDefault: () => {},
                    currentTarget: imageContainerRef.current,
                    deltaY: -100, // negative for zoom in
                    clientX: effectiveWidth / 2,
                    clientY: effectiveHeight / 2
                };
                
                handleWheel(simulatedEvent);
                return false;
            } else if (e.key === '-' || e.code === 'NumpadSubtract') {
                e.preventDefault(); // Prevent the default browser zoom
                
                // Simulate a wheel event with positive deltaY (zoom out)
                const simulatedEvent = {
                    preventDefault: () => {},
                    currentTarget: imageContainerRef.current,
                    deltaY: 100, // positive for zoom out
                    clientX: effectiveWidth / 2,
                    clientY: effectiveHeight / 2
                };
                
                handleWheel(simulatedEvent);
                return false;
            }
        }
    };

    // Add event listener for keyboard shortcuts
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [transform]); // Add transform to the dependency array

    // Prefetch neighbors (optional, free speed!)
    useEffect(() => {
        const preload = (src) => {
            if (!src) return;
            const i = new Image();
            i.src = src.includes(':\\')
                ? toFileUrl(src)
                : (src.startsWith('data:') || src.startsWith('http') ? src : `data:image/*;base64,${src}`);
            };
            preload(props.prevImageSrc);
            preload(props.nextImageSrc);
        }, [props.prevImageSrc, props.nextImageSrc]);

        const defaultTransform = { scale: 1, translateX: 0, translateY: 0 };
        const resetTransform = () => {
        setTransform(defaultTransform);
        localStorage.setItem('imageViewerTransform', JSON.stringify(defaultTransform));
    };

    let imageSrc;
    if (electronBridge.isElectron && props.image && props.image.includes(":\\")) {
        // Electron environment and file path (Windows or Unix)
        imageSrc = toFileUrl(props.image);
    } else if (props.image && props.image.startsWith('http')) {
        // Remote URL
        imageSrc = props.image;
    } else if (props.image) {
        // Assume base64
        imageSrc = `data:image/png;base64,${props.image}`;
    }

    return (
        <div
            className="fixed inset-0 z-[10001] bg-gray-900/80"
            tabIndex={0}
        >
            {/* full-viewport, centers content, bounds zoom/pan */}
            <div
            ref={imageContainerRef}
            className="relative w-full h-full flex items-center justify-center overflow-hidden"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            >
                <img
                    className="relative max-w-[95vw] max-h-[90vh] object-contain select-none"
                    src={imageSrc}
                    alt={`Generated image: ${props.seed}`}
                    style={imageStyle}
                    draggable={false}
                />
                <div className={"w-full absolute right-0 top-0 flex flex-row justify-end items-center justify-self-start z-[999]"} onKeyDown={(e) => handleKeyDown(e)}>
                        <button className={"p-3 text-white m-2 me-8 hover:text-yellow transition bg-yellow"} onClick={props.closeImageViewer}>
                            <CloseIcon alt='Close Full Image Viewer' className='h-7'/>
                        </button>
                </div>
                {/* Prev click area + chevron */}
                {props.total > 1 && props.onPrev && (
                <>
                    {/* wide, invisible click target for easy navigation */}
                    <button
                    className="absolute left-0 top-0 h-full w-18 flex items-center justify-start text-white/80 hover:text-white"
                    onClick={() => { resetTransform(); props.onPrev(); }}
                    onMouseDown={(e) => e.stopPropagation()}
                    aria-label="Previous image"
                    title="Previous (←)"
                    >
                    {/* <span className="text-4xl leading-none select-none">‹</span> */}
                        <DoubleLeftIcon />
                    </button>
                </>
                )}

                {/* Next click area + chevron */}
                {props.total > 1 && props.onNext && (
                <>
                    <button
                    className="absolute right-0 top-0 h-full w-18 flex items-center justify-end text-white/80 hover:text-white" 
                    onClick={() => { resetTransform(); props.onNext(); }}
                    onMouseDown={(e) => e.stopPropagation()}
                    aria-label="Next image"
                    title="Next (→)"
                    >
                    {/* <span className="text-4xl leading-none select-none w-full">›</span> */}
                        <DoubleRightIcon />
                    </button>
                </>
                )}

                {/* Top center counter */}
                {typeof props.currentIndex === 'number' && typeof props.total === 'number' && (
                <div className="absolute top-3 left-1/2 -translate-x-1/2 rounded-full bg-black/70 px-3 py-1 text-xl text-white font-semibold">
                    {props.currentIndex + 1} / {props.total}
                </div>
                )}
                {props.tag ? 
                    <div className={`absolute flex flex-col gap-3 group-hover:hidden bottom-0 left-0 rounded-tr px-3 py-2 bg-dark-blue/50 border-2 text-sm w-44`}>
                        <p className="text-lg font-semibold">Image Tag</p>
                        <p className="text-yellow font-bold text-lg my-1">{props.tag}</p>    
                        <button className="rounded-lg bg-yellow py-2 px-3 shadow-md font-bold text-m uppercase" onClick={openTagModal}>Add Tag(s)</button>
                    </div>
                :
                    <div className={`absolute flex flex-col gap-3 group-hover:hidden bottom-0 left-0 rounded-tr px-3 py-2 bg-dark-blue/50 border-2 text-sm w-44`}>
                        <p className="text-lg font-semibold">Add Image Tag</p>
                        <button className="rounded-lg bg-yellow py-2 px-3 shadow-md font-bold text-m uppercase" onClick={openTagModal}>Add Tag(s)</button>
                    </div>
                }
            </div>
            <Modal open={open} onClose={() => setOpen(false)} center container={document.querySelector('.main-content') || undefined}>
                <h2 className="text-2xl mb-5 font-bold">Category</h2>
                <p>
                    Edit the tags you would like to add with the image
                </p>
                <div className="flex flex-row items-center justify-between my-5">
                    <p className="place-content-start">Original Tag: <span className="font-bold">{props.tag}</span></p>
                </div>
                <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                    <label className="block mb-2 text-sm font-medium" htmlFor="existing">Existing Category</label>
                    <Select options={options} components={animatedComponents} onChange={(e) => setSelectedOptions(e)} isMulti isClearable onKeyDown={(e) => handleKeyDown(e)}/>
                </div>
                <div className="flex flex-row items-center">
                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                    <h1 className="mx-4 font-bold text-xl">OR</h1>
                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                </div>
                    <p>
                        Type in a new category to have more ease in sorting your images
                    </p>
                    <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                        <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">New Category</label>
                        <input type="text" name="emailAddress" className="w-full rounded-lg text-dark-blue border border-dark-blue p-2" placeholder="Category"
                        value={inputTag} onChange={(e) => setInputTag(e.target.value)} onKeyDown={(e) => handleKeyDown(e)}/>
                    </div>
                <div className="flex flex-row justify-center gap-4">
                    <button onClick={() => editTagOnImage()} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">
                        {tagLoading ?
                            <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                            </svg>
                        :
                            null
                        }
                        Categorize
                    </button>
                    <button onClick={() => setOpen(false)} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-dark-blue text-yellow shadow font-bold">Cancel</button>
                </div>
            </Modal>
        </div>
    )
}